import dayjs from "dayjs"
require("dayjs/locale/el")

const formatDate = date => {
  return dayjs(date).locale("el").format("DD/MM/YYYY")
}

export default formatDate
